/* eslint-disable import/prefer-default-export */
export const getDateWithoutTime = (date) => {
  const localDate = new Date(date);
  localDate.setHours(0, 0, 0);
  return localDate;
};
export const openLink = (link) => {
  window.open(link, '_blank');
};
